import { GraphQLError } from 'graphql';
import { graphql } from 'msw';

import { RegisterUserMutation } from '../queries/registerUser.generated';

export const generateRegistrationHandler = (
    response: RegisterUserMutation['registerUser']
) => {
    return graphql.mutation<RegisterUserMutation>(
        'registerUser',
        (_, res, ctx) => {
            return res(ctx.data({ registerUser: response }));
        }
    );
};

export const generateRegistrationErrorHandler = (
    errorMessage: GraphQLError['message']
) => {
    const graphqlError = new GraphQLError(errorMessage);

    return graphql.mutation<RegisterUserMutation>(
        'registerUser',
        (_, res, ctx) => {
            return res(ctx.errors([graphqlError]));
        }
    );
};

export const defaultRegistrationHandler = generateRegistrationHandler({
    success: true,
    pageAfterLoginUrl: '/',
    errorMessage: null,
    errorCode: null,
    errorField: null
});

export const registrationFailHandler = generateRegistrationHandler({
    success: false,
    pageAfterLoginUrl: '/',
    errorMessage: 'This email address is already in use',
    errorCode: 'EMAIL_EXISTS',
    errorField: 'email'
});

export const registrationFailNoCodeHandler = generateRegistrationHandler({
    success: false,
    pageAfterLoginUrl: '/',
    errorMessage: '',
    errorCode: null,
    errorField: 'password'
});

export const registrationFailMinimalHandler = generateRegistrationHandler({
    success: false,
    pageAfterLoginUrl: '/',
    errorMessage: null,
    errorCode: null,
    errorField: null
});

export const registrationServerErrorHandler =
    generateRegistrationErrorHandler('Arbitrary error');
